// extracted by mini-css-extract-plugin
module.exports = {"search-user-page":"SearchUser_search-user-page__1rG79","page-content":"SearchUser_page-content__2If0g"};